
export const getManagersDisciplines = (members, managersId) => members
  .filter(member => managersId.value.includes(member.id))
  .reduce((acc, manager) =>
    [...acc, manager.speciality]
    , []).filter(Boolean)
